module.exports = __webpack_public_path__ + "static/Unbounded-Medium-4D-b619cc91fa3e1807f8c37379f3e8c83a.woff2";